import moment from 'moment';
import { getData } from '@/components/report/service';
import { SqlBase } from '../Sql/common'
import { TotalQuery, MustQuery, ProductQuery } from '../Sql/Totals';

export default {
  namespace: 'forecastCenterDepartBoardTotal',
  state: {
    // table 1
    dataList1: [],
    // table 2
    dataList2: [],
    // table 3
    dataList7: [],
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      yield put({ type: 'getTotalTable' });
      yield put({ type: 'getMustTable' });
      yield put({ type: 'getProductTable' });
      
    },
    *getTotalTable(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        return {
          simpleGranularity: 'all',
          startDate: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endDate: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
          aggregators: SqlBase(),
        }
      });
      const filter = TotalQuery(centerFilter);
      const arr = [];
      for (let i = 0; i < filter.length; i++) {
        const obj = {
          index: i
        };
        obj.name = i === 0 ? '实际' : (i === 1 ? '预计' : '预报')
        for (let j = 0; j < filter[i].length; j++) {
          const data = yield call(getData, { ...query, ...filter[i][j] });
          let result = data[0] || {};
          obj[`goodsWeight${j}`] = result.goodsWeight;
          obj[`goodsVolume${j}`] = result.goodsVolume;
          obj[`piece${j}`] = result.piece;
          obj[`ticket${j}`] = result.ticket;
        }
        arr.push(obj)
      }
      yield put({
        type: 'update',
        payload: {
          dataList1: arr
        },
      });
    },
    *getMustTable(_, { call, put, select }) {
      // const arr = [];
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        return {
          simpleGranularity: 'all',
          startDate: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endDate: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
          aggregators: SqlBase(),
        }
      });
      const filter = MustQuery(centerFilter);
      const arr = [];
      for (let i = 0; i < filter.length; i++) {
        const obj = {
          index: i
        };
        obj.name = i === 0 ? '实际' : (i === 1 ? '预计' : '预报')
        for (let j = 0; j < filter[i].length; j++) {
          const data = yield call(getData, { ...query, ...filter[i][j] });
          let result = data[0] || {};
          obj[`goodsWeight${j}`] = result.goodsWeight;
          obj[`goodsVolume${j}`] = result.goodsVolume;
          obj[`piece${j}`] = result.piece;
          obj[`ticket${j}`] = result.ticket;
        }
        arr.push(obj)
      }
      yield put({
        type: 'update',
        payload: {
          dataList2: arr
        },
      });
    },
    *getProductTable(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        return {
          simpleGranularity: 'all',
          startDate: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endDate: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
          aggregators: SqlBase(),
        }
      });
      
      const filter = ProductQuery(centerFilter);
      const arr = [];
      for (let i = 0; i < filter.length; i++) {
        const obj = {
          index: i
        };
        obj.name = i === 0 ? '实际' : (i === 1 ? '预计' : '预报')
        for (let j = 0; j < filter[i].length; j++) {
          const data = yield call(getData, { ...query, ...filter[i][j] });
          let result = data[0] || {};
          obj[`goodsWeight${j}`] = result.goodsWeight;
          obj[`goodsVolume${j}`] = result.goodsVolume;
          obj[`piece${j}`] = result.piece;
          obj[`ticket${j}`] = result.ticket;
        }
        arr.push(obj)
      }
      yield put({
        type: 'update',
        payload: {
          dataList7: arr
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}